import { render, staticRenderFns } from "./OidcCallbackError.vue?vue&type=template&id=7059289c&"
import script from "./OidcCallbackError.vue?vue&type=script&lang=js&"
export * from "./OidcCallbackError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports